"use client";

import { ReactNode } from "react";

import { getQueryClient } from "@saas/core/react-query/create-query-client/create-query-client";
import { FlagKeys } from "@saas/flags/utils/@type/flag-keys/flag-keys";
import { Snackbar } from "@saas/layout/ui/snackbar/snackbar";
import { AlertProvider } from "@saas/shared/feature/alert/alert";

import { QueryClientProvider } from "@tanstack/react-query";
import { FlagsProvider } from "flagged";

export interface IProvidersProps {
  children: ReactNode;
  flags?: Record<FlagKeys, boolean>;
}

export const Providers = ({ children, flags }: IProvidersProps) => {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <FlagsProvider features={flags}>
        <AlertProvider>
          <Snackbar />
          {children}
        </AlertProvider>
      </FlagsProvider>
    </QueryClientProvider>
  );
};
